import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ILootboxCard, IPrizeTexture } from "../lootbox.interface";
import {
  CURRENCY,
  CURRENCY_SYMBOL, CUSTOM_PRIZE_TYPE, PLATFORM_TYPES, SPIN_WIN_PRIZES,
  STATUS_CODES, STORAGE_KEYS, convertNum, convertNumToCurr,
  getEllipsis,
  verifyLanguage
} from "src/app/shared/constants/app-enums";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/services/event.service";
import { Sound } from "@pixi/sound";
import {
  Application,
  Container,
  Assets,
  Texture,
  BlurFilter,
  Sprite,
  Graphics,
  Text, ContainerChild,
  FillGradient
} from "pixi.js";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SpinWinComponent } from "../spin-win/spin-win.component";
import { CommonApiService } from "src/app/services/common-api-service";
import { API_Const } from "src/app/shared/constants/apiRouteConst";
import { Subscription, interval, takeWhile, tap } from "rxjs";
import { AnimationOptions } from "ngx-lottie";
import { PopupService } from "src/app/services/popup.service";
import { GameAPIService } from "src/app/services/game-api.service";
import { BH_LOGIN_URL, MESSAGES, sessionSubject, SPINNER_GRADIENT_COLORS, STATIC_NFT_IMG } from "src/app/shared/constants/common.constants";
import { environment } from "src/environments/environment";
import { loadAndUseImage, rxSetTimeout } from "src/app/shared/utils/shared-common.utils";
import { HttpErrorResponse } from "@angular/common/http";
import { ICommonObject } from "src/app/shared/constants/common.interface";

@Component({
  selector: "app-lootbox-contents",
  templateUrl: "./lootbox-contents.component.html",
  styleUrls: ["./lootbox-contents.component.scss"],
})
export class LootboxContentsComponent implements OnInit, OnDestroy {
  lang: any;
  options: AnimationOptions = {
    path: "assets/images/animations/coin-transfer-animation.json",
    loop: true,
    autoplay: true,
    renderer: "svg",
  };
  weights: any[] = [];
  cards: ILootboxCard[] = [];
  isFastSpin = false;
  lootboxId!: string;
  spinFee!: number;
  spinnerContainer!: HTMLElement;
  running = false;
  pixi = new Application();
  reelContainer = new Container();
  arrowContainer = new Container();
  speed = 0;
  cardWidth = 200; // Width of each card
  cardHeight = 308; // Height of each card
  sound = Sound.from("assets/sounds/spin-ticker.mp3");
  prizeCardIndex!: number;
  stopSpinning = false;
  lootboxFetchError = false;
  spinHasError = false;
  uploadedAssets: ICommonObject<IPrizeTexture> = {} as ICommonObject<IPrizeTexture>;
  subscriptions: Subscription[] = [];
  lessBalance = false;
  checkingBalance = true;
  spinWinModalRef!: BsModalRef;
  showCoinTransfer = false;
  isProd = environment.production;
  fetchingAssets = false;
  isUSDDefault = false;
  CURRENCY = CURRENCY;
  CURRENCY_SYMBOL = CURRENCY_SYMBOL;
  userBalance = 0;
  gameSession!: string;
  previousHighlightedIndex = -1;
  tickerSoundPlayed = false;
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024;
  isTrySpin = false;
  arrowPosition!: number;
  spinWinBg!: string;
  prizeBg!: string;
  prizeWon!: ILootboxCard;
  lootboxUpdatedAt!: string;
  lootboxUpdated = false;
  convertNum = convertNum;
  sessionBalance: { [key: string]: { currentSessionFreeSpinBalance:number } } = {}
  marketingFreeSpinBalance = 0;
  gameId!: string;
  fetchingDetails = false;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private eventService: EventService,
    private modalService: BsModalService,
    private apiService: CommonApiService,
    private router: Router,
    private popupService: PopupService,
    private gameAPIService: GameAPIService,
    private location: Location,
  ) {
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        const { lang, id } = params;
        this.lootboxId = id;
        this.sessionBalance[this.lootboxId] = { currentSessionFreeSpinBalance: 0 };
        if (lang && verifyLanguage(lang)) {
          this.lang = lang;
        } else {
          const localLang = localStorage.getItem("currentlang");
          if (localLang && verifyLanguage(localLang)) {
            this.lang = localLang;
          } else {
            const userLang = navigator.language?.split("-")[0];
            this.lang = userLang && verifyLanguage(userLang) ? userLang : "en";
          }
        }
      })
    );
    this.translate.setDefaultLang(this.lang);
    this.translate.use(this.lang);
    this.eventService.setLang(this.lang);
    this.getLootboxDetails();
    if (!this.gameAPIService.getIsDemo) {
      this.checkUserBalance();
    } else {
      this.checkingBalance = false;
      this.userBalance = 0;
    }
    // Converts img from opensea to supported formats
    // extensions.add(this.imageDelivery)
    this.isUSDDefault = this.gameAPIService.userCurrency === CURRENCY.USD;
    this.subscriptions.push(sessionSubject.subscribe(session => {
      this.gameSession = session
    }));
    if (!this.gameAPIService.getIsDemo) {
      this.gameSession = this.gameAPIService.sessionToken as string;
    }
  }
  ngOnInit(): void { }

  @HostListener("window:resize", ["$event"])
  onWindowResize(event: Event): void {
    this.pixi.resizeTo = this.spinnerContainer;
    if (this.pixi.renderer) {
      this.pixi.renderer.resize(
        this.spinnerContainer.offsetWidth,
        this.spinnerContainer.offsetHeight
      );
    }
    let rightGradient = -1;
    this.pixi.stage.children.forEach((child: ContainerChild, index: number) => {
      if (child.label === 'rightGradient') {
        rightGradient = index;
      }
    });
    if (rightGradient > -1) {
      this.pixi.stage.children[rightGradient].x = this.spinnerContainer.clientWidth - 150;
    }
    this.arrowContainer.children[0].x = (this.spinnerContainer.clientWidth / 2) - 40;
    this.arrowPosition = (this.spinnerContainer.clientWidth / 2);
    this.reelContainer.children.forEach((sprite: Container, index: number) => {
      let cardIsCentered = sprite.x > 0 &&
        sprite.x < this.spinnerContainer.offsetWidth &&
        this.arrowPosition - sprite.x < 90 &&
        sprite.x - this.arrowPosition < 90;
      if (cardIsCentered) {
        this.previousHighlightedIndex = index;
      }
    });
    // Adjusts x-offset according to the resized window
    this.reelContainer.x = this.getXOffset;
  }

  /**
   * Makes an API call to check the user's balance for spinning a lootbox.
   * Updates the balance and error status accordingly.
   * If 'maintainBalance' is false, updates the user's balance.
   */
  checkUserBalance(maintainBalance?: boolean) {
    this.subscriptions.push(
      this.apiService
        .post(API_Const.lootboxes.balance, {}, true)
        .subscribe({
          next: (res) => {
            const { hasErrors = false, body = null } = res?.result;
            if (hasErrors) {
              window.open(BH_LOGIN_URL, "_parent");
              return;
            }
            this.lessBalance = this.spinFee > (body?.totalBalance || 0);
            this.checkingBalance = false;
            if (!maintainBalance) {
              this.userBalance = +body?.totalBalance || 0;
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 401) {
              window.open(BH_LOGIN_URL, "_parent");
            }
            this.spinHasError = true;
            this.checkingBalance = false;
            // Return when status is 0, interceptor handles this error
            if (!err.status) {
              return;
            }
            if (err?.error?.message) {
              this.popupService.messsageAlert("error", err?.error?.message);
              return;
            }
            this.popupService.messsageAlert("error", MESSAGES.SOMETHING_WENT_WRONG);
          },
        })
    );
  }

  /**
 * Makes an API call to check the user's free spin balance for spinning a lootbox.
 * Updates the balance and error status accordingly.
 */
  checkFreeSpinBalance() {
    this.subscriptions.push(
      this.apiService
        .post(`${API_Const.lootboxes.bonus}`, { game: this.gameId }, true)
        .subscribe({
          next: (res) => {
            const { inGameBalance = 0, marketingBonusBalance = 0 } = res.result;
            this.marketingFreeSpinBalance = marketingBonusBalance + inGameBalance;
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 401) {
              window.open(BH_LOGIN_URL, "_parent");
            }
            this.spinHasError = true;
            this.checkingBalance = false;
            // Return when status is 0, interceptor handles this error
            if (!err.status) {
              return;
            }
            if (err?.error?.message) {
              this.popupService.messsageAlert("error", err?.error?.message);
              return;
            }
            this.popupService.messsageAlert("error", MESSAGES.SOMETHING_WENT_WRONG);
          },
        })
    );
  }


  /**
   * Makes an API Call to fetch lootbox details using the ID and fills the cards array
   *  @param refreshData: Send true when you want to fetch latest updatedAt, Does not update Spinner
   */
  getLootboxDetails(refreshData?: boolean) {
    this.fetchingDetails = true;
    this.cards = [];
    this.subscriptions.push(
      this.apiService
        .get(`${API_Const.lootboxes.game}/${this.lootboxId}`, !this.gameAPIService.getIsDemo)
        .subscribe({
          next: async (res) => {

            const {
              result: { fee_usd, fee_euro, prizeToGame, isDisabled, updatedAt, gameId },
            } = res;
            if (isDisabled) {
              this.router.navigate([this.lang, "lootboxes"], {
                queryParams: {
                  token: localStorage.getItem(STORAGE_KEYS.SESSION),
                  is_demo: localStorage.getItem(STORAGE_KEYS.IS_DEMO),
                  currency: localStorage.getItem(STORAGE_KEYS.CURRENCY),
                  platform: localStorage.getItem(STORAGE_KEYS.PLATFORM)
                }
              });
            }
            this.spinFee = this.isUSDDefault ? +(+fee_usd).toFixed(2) : +(+fee_euro).toFixed(2);
            this.fetchingAssets = true;
            this.lootboxUpdatedAt = updatedAt;
            this.gameId = gameId;
            if(!localStorage.getItem(STORAGE_KEYS.IS_DEMO)){
              this.checkFreeSpinBalance();
            }
            await Promise.all(prizeToGame.map(async (prize: any) => {
              if (!prize || prize.isDisabled || !Object.keys(prize).length) {
                return;
              }
              let prizeDetails = this.processPrizeDetails(prize);
              this.weights.push({
                type: prize.type,
                value: prize.id,
                weight: prizeDetails.probability * 100
              });
              this.cards.push({
                type: prizeDetails.type,
                probability: prizeDetails.probability * 100,
                ...prizeDetails,
                prizeId: prizeDetails.id,
                unit: this.isUSDDefault ? CURRENCY.USD : CURRENCY.EURO
              });
              if (prize?.imageUrl) {
                try {
                  const imageTexture = await loadAndUseImage(prize?.imageUrl);
                  this.uploadedAssets[`${prize.id}`] = { imageTexture };
                } catch (error) {
                  this.lootboxFetchError = true;
                }
              };
              // USING STATIC CURRENCY LOGOS
              // if (prize?.currency) {
              //   try {
              //     const currencyTexture = await loadAndUseImage(prize.currency?.currencyImage);
              //     this.uploadedAssets[`${prize.id}`] = { ...this.uploadedAssets[`${prize.id}`], currencyTexture };
              //   } catch (error) {
              //     this.lootboxFetchError = true;
              //   }
              // }
            }));
            // When prizes in the lootbox are same, want to fetch the latest updatedAt for lootbox
            this.fetchingDetails = false;
            if (refreshData) {
              this.fetchingAssets = false;
              return;
            }
            if (document.getElementById("spinner")) {
              this.spinnerContainer = document.getElementById(
                "spinner"
              ) as HTMLElement;
              this.pixi.resizeTo = this.spinnerContainer;
              this.loadPixi();
            }
          },
          error: (err: HttpErrorResponse) => {
            this.spinHasError = true;
            this.fetchingDetails = false;
            this.fetchingAssets = false;
            // Return when status is 0, interceptor handles this error
            if (!err.status) {
              return;
            }
            if (err?.status === STATUS_CODES.NOT_FOUND) {
              this.popupService.messsageAlert("error", err?.error?.message);
              this.router.navigate([this.lang, "lootboxes"], {
                queryParams: {
                  token: localStorage.getItem(STORAGE_KEYS.SESSION),
                  is_demo: localStorage.getItem(STORAGE_KEYS.IS_DEMO),
                  currency: localStorage.getItem(STORAGE_KEYS.CURRENCY),
                  platform: localStorage.getItem(STORAGE_KEYS.PLATFORM)
                }
              });
            }
            if (err?.error?.message) {
              this.popupService.messsageAlert("error", err?.error?.message);
              return;
            }
            this.popupService.messsageAlert("error", MESSAGES.SOMETHING_WENT_WRONG);
          },
        })
    );
  }

  processPrizeDetails(prize: any): any {
    let prizeDetails: any =
    {
      type: prize.type,
      probability: prize.probability * 100,
      id: prize.id,
      unit: this.isUSDDefault ? CURRENCY.USD : CURRENCY.EURO,
      imageUrl: prize?.imageUrl,
      prizeWinImage: prize?.prizeWinImage,
    }
    if (
      prize.type === SPIN_WIN_PRIZES.CASINO_TOKEN ||
      prize.type === SPIN_WIN_PRIZES.CASH
    ) {
      if (prize.type === SPIN_WIN_PRIZES.CASINO_TOKEN) {
        prizeDetails = {
          ...prizeDetails,
          currency: prize.currency
        }
      }
      return {
        ...prizeDetails,
        tokenQuantity: prize.type === SPIN_WIN_PRIZES.CASINO_TOKEN ? prize.amountInToken : (this.isUSDDefault ? prize.amountInUsd : prize.amountInEuro)
      };
    } else if (prize.type === SPIN_WIN_PRIZES.NFT) {
      if (!prize.isDisabled) {
        let maxPrice = 0, minPrice = 0, currentPrice = 0, resellValue = 0;
        if (this.isUSDDefault) {
          minPrice = prize.metaData.lowerLimitUsd;
          maxPrice = prize.metaData.upperLimitUsd;
          currentPrice = prize.amountInUsd;
          resellValue = prize.metaData.nftRevalueUsd;
        } else {
          minPrice = prize.metaData.lowerLimitEuro;
          maxPrice = prize.metaData.upperLimitEuro;
          currentPrice = prize.amountInEuro;
          resellValue = prize.metaData.nftRevalueEuro;
        }
        return {
          ...prizeDetails,
          nft: {
            currentPrice,
            maxPrice,
            minPrice,
            img: prize.imageUrl,
            name: prize.metaData.collection,
            id: prize.metaData.nftId,
            resellValue,
            unit: this.isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO,
            slug: prize.metaData.slug
          },
        };
      }
      const { replacement } = prize;
      return this.processPrizeDetails(replacement);
    } else if (prize.type === SPIN_WIN_PRIZES.CUSTOM) {
      if (!prize.isDisabled) {
        return {
          ...prizeDetails,
          tokenQuantity: !this.isUSDDefault ? prize?.amountInEuro : prize?.amountInUsd,
          customPrize: prize.customPrize
        };
      }
      const { replacement } = prize;
      return this.processPrizeDetails(replacement);
    }
    return {
      ...prizeDetails,
      numberOfFreeSpin: prize.metaData?.numberOfFreeSpins || 1
    }
  }

  weightedRandom(weights: any[]) {
    const totalWeight = weights.reduce((acc, val) => acc + val.weight, 0);
    let randomNumber = Math.random() * totalWeight;

    for (const item of weights) {
      if (randomNumber < item.weight) {
        return item.value;
      }
      randomNumber -= item.weight;
    }
  }

  resizePixi() {
    const width = this.spinnerContainer.offsetWidth;
    const height = this.spinnerContainer.offsetHeight;
    this.pixi.renderer.resize(width, height);
  }

  /**
   * Initializes pixijs app and its properties
   */
  async loadPixi() {
    await this.pixi.init({
      background: this.eventService.getCssVariableValue("--bgColor"),
      resizeTo: document.getElementById("spinner") as HTMLElement,
      autoDensity: true,
      resolution: window.devicePixelRatio,
      roundPixels: true
    });
    this.pixi.resize();
    this.pixi.renderer.view.autoDensity = true;
    // Append the application canvas to the document body
    (document.getElementById("spinner") as HTMLElement).appendChild(
      this.pixi.canvas
    );

    // Load the textures
    const assets = Assets.load([
      "assets/images/prize-spinner/free-spin.png",
      "assets/images/prize-spinner/crypto-reward.png",
      "assets/images/prize-spinner/arrows.svg",
      "assets/images/prize-spinner/token-card.png",
      "assets/images/svg-icons/wall-token.svg",
      "assets/images/svg-icons/usd-coin.svg",
      "assets/images/svg-icons/euro-coin.svg",
      "assets/images/prize-spinner/free-spin-bg.png",
      STATIC_NFT_IMG,
      'assets/images/prize-spinner/cash-reward-bg.png',
      'assets/images/prize-spinner/cash-chest.png',
      'assets/images/currency/BTC-logo.webp',
      'assets/images/currency/ETH-logo.webp',
      'assets/images/currency/USDT-logo.webp',
      'assets/images/currency/WSM-logo.webp',
    ]);

    assets.then(() => {
      this.createSpinner();
      rxSetTimeout(200).subscribe({
        next: () => this.fetchingAssets = false
      });

    }).catch(() => {
      this.popupService.messsageAlert('error', MESSAGES.SOMETHING_WENT_WRONG)
    })

  }

  createSpinner() {
    const SYMBOL_SIZE = 150;

    this.reelContainer.x = this.getXOffset;

    const reel = {
      container: this.reelContainer,
      symbols: [],
      position: 0,
      previousPosition: 0,
      blur: new BlurFilter(),
    };

    reel.blur.blurX = 0;
    reel.blur.blurY = 0;
    this.reelContainer.filters = [reel.blur];
    const multiplier = Math.ceil(10 / this.cards.length);

    // Build the symbols
    let cardIndex = 0;
    const cardsLength = this.cards.length;
    for (let j = 0; j < cardsLength * multiplier; j++) {
      const currentPrize = this.cards[cardIndex];
      const cardContainer = new Container({
        label: currentPrize.prizeId.toString(),
      });
      cardContainer.x = j * (this.cardWidth + 8); // Adjust spacing between cards
      cardContainer.y = 70; // Adjust vertical position of cards

      // Creating white background
      const whiteBackground = new Graphics()
        .roundRect(0, 0, this.cardWidth, this.cardHeight, 14)
        .fill(this.eventService.getCssVariableValue("--cardBgColor"))
        .stroke({
          width: 2,
          color: this.eventService.getCssVariableValue("--borderColor"),
        });

      const whiteTexture = this.pixi.renderer.generateTexture(whiteBackground);
      const whiteBackgroundSprite = new Sprite(whiteTexture);
      cardContainer.addChild(whiteBackgroundSprite);

      let width = 80;
      let height = 80;
      let x = this.cardWidth / 2;
      let y = this.cardHeight / 2;
      let defaultTexture = (currentPrize.imageUrl ? this.uploadedAssets[currentPrize.prizeId]?.imageTexture : Texture.from(
        "assets/images/prize-spinner/free-spin.png"
      ));

      // GENERATE CARDS ACCORDING TO PRIZE -> NEED TO UPDATE DURING API
      if (currentPrize.type === SPIN_WIN_PRIZES.FREE_SPIN) {
        this.generateFreeSpinCard(cardContainer, currentPrize.numberOfFreeSpin as number, !currentPrize?.imageUrl);
        height = 170;
        width = 170;
        if (currentPrize?.imageUrl) {
          y = this.cardHeight / 2 - 4;
          height = 228;
        } else {
          x += 5;
        }
      } else if (currentPrize.type === SPIN_WIN_PRIZES.NFT) {
        this.generateNFTCard(
          cardContainer,
          `${getEllipsis(currentPrize.nft?.name as string, 24)}`,
          `${getEllipsis(('#' + currentPrize.nft?.id) as string, 22)}`,
          currentPrize.nft?.currentPrice || 123
        );
        height = 202;
        width = this.cardWidth - 32;
        y = this.cardHeight / 2 - 16;
        defaultTexture = (currentPrize.imageUrl ? this.uploadedAssets[currentPrize.prizeId]?.imageTexture : Texture.from(
          STATIC_NFT_IMG
        ));
      }
      else if (currentPrize.type === SPIN_WIN_PRIZES.CUSTOM) {
        this.generateCustomPrizeCard(
          cardContainer,
          currentPrize
        );
        width = this.cardWidth - 32;
        y = this.cardHeight / 2 - 4;
        height = 228;
        defaultTexture = (currentPrize.imageUrl ? this.uploadedAssets[currentPrize.prizeId]?.imageTexture : Texture.from(
          STATIC_NFT_IMG
        ));
      } else if (currentPrize.type === SPIN_WIN_PRIZES.CASH) {
        const currencySymbol = currentPrize.unit === CURRENCY.USD ? 'assets/images/svg-icons/usd-coin.svg' : 'assets/images/svg-icons/euro-coin.svg'
        defaultTexture = (currentPrize.imageUrl ? this.uploadedAssets[currentPrize.prizeId]?.imageTexture : Texture.from(
          'assets/images/prize-spinner/cash-chest.png'
        ));
        if (currentPrize.imageUrl) {
          width = this.cardWidth - 32;
          y = this.cardHeight / 2 - 4;
          height = 228;
        }
        this.generateCashCard(
          cardContainer,
          currentPrize.tokenQuantity as number,
          currencySymbol,
          !currentPrize?.imageUrl
        );
      }
      else {
        defaultTexture = currentPrize.imageUrl ? this.uploadedAssets[currentPrize.prizeId]?.imageTexture : Texture.from(
          "assets/images/prize-spinner/crypto-reward.png"
        );
        if (currentPrize.imageUrl) {
          // height = 202;
          width = this.cardWidth - 32;
          y = this.cardHeight / 2 - 4;
          height = 228;
        }
        this.generateCryptoCard(
          cardContainer,
          currentPrize,
          !currentPrize?.imageUrl
        );
      }

      // Create sprite for the image and position it at the center of the card
      const imageSprite = new Sprite({
        texture: defaultTexture,
        height,
        width,
        roundPixels: true,
      });
      imageSprite.anchor.set(0.5);
      imageSprite.x = x;
      imageSprite.y = y;
      cardContainer.addChild(imageSprite);
      this.reelContainer.addChild(cardContainer);

      if (cardIndex === this.cards.length - 1) {
        cardIndex = 0;
      } else {
        cardIndex++;
      }
    }

    this.pixi.stage.addChild(this.reelContainer);
    const margin = (this.pixi.screen.height - SYMBOL_SIZE * 3) / 2;
    this.reelContainer.y = margin;

    // Add center arrows
    this.addArrows();
    this.addEndGradient()

  }

  /**
   * Adds fading out effect on right and left of the spinner
   */
  addEndGradient() {
    // Create a fill gradient
    const leftGradientFill = new FillGradient(0, this.spinnerContainer.offsetHeight, 150, this.spinnerContainer.offsetHeight);
    const rightGradientFill = new FillGradient(0, this.spinnerContainer.offsetHeight, 150, this.spinnerContainer.offsetHeight);

    // Add the color stops to the fill gradient
    SPINNER_GRADIENT_COLORS.forEach((number, index) => {
      leftGradientFill.addColorStop((index / 6), number);
      rightGradientFill.addColorStop((6 - index) / 6, number);
    });

    // LEFT SIDE FADE-OUT GRADIENT
    const leftGradient = new Graphics()
      .roundRect(0, 0, 150, this.spinnerContainer.offsetHeight, 0)
      .fill(leftGradientFill);

    const leftGradientTexture = this.pixi.renderer.generateTexture({
      target: leftGradient, textureSourceOptions: {
        scaleMode: 'nearest'
      },
      resolution: window.devicePixelRatio
    });
    const leftGradientSprite = new Sprite(leftGradientTexture);

    // RIGHT SIDE FADE-OUT GRADIENT
    const rightGradient = new Graphics()
      .rect(0, 0, 150, this.spinnerContainer.offsetHeight)
      .fill(rightGradientFill).rotateTransform(-180);

    const rightGradientTexture = this.pixi.renderer.generateTexture({
      target: rightGradient, textureSourceOptions: {
        scaleMode: 'nearest'
      },
      resolution: window.devicePixelRatio
    });
    const rightGradientSprite = new Sprite(rightGradientTexture);
    rightGradientSprite.x = this.spinnerContainer.clientWidth - 150;
    rightGradientSprite.label = 'rightGradient';

    // ADDING BOTH GRADIENTS TO SPINNER
    this.pixi.stage.addChild(rightGradientSprite);
    this.pixi.stage.addChild(leftGradientSprite);
  }

  /**
   * Adds arrows to the center of the canvas
   */
  addArrows() {
    const symbol = new Sprite({
      texture: Texture.from("assets/images/prize-spinner/arrows.svg"),
      height: 390,
      width: 80,
      roundPixels: true,
    });
    symbol.x = (this.spinnerContainer.clientWidth / 2) - 40;
    this.arrowPosition = symbol.x + 40;
    symbol.y = -10;
    this.arrowContainer.addChild(symbol);
    this.pixi.stage.addChild(this.arrowContainer);
    this.reelContainer.children.forEach((sprite: Container, index: number) => {
      let cardIsCentered = sprite.x > 0 &&
        sprite.x < this.spinnerContainer.offsetWidth &&
        this.arrowPosition - sprite.x < 90 &&
        sprite.x - this.arrowPosition < 90;
      if (cardIsCentered) {
        this.previousHighlightedIndex = index;
      }
    });
  }

  /**
   * Checks user balance
   */
  checkBalanceAndSpin() {
    if (this.gameAPIService.getIsDemo) {
      window.open(BH_LOGIN_URL, "_parent");
      return;
    }
    if (this.lessBalance) {
      return;
    }
    this.processSpin(false);
  }

  /**
   * Executes TRY IT Flow
   */
  processSpin(isTrySpin: boolean) {
    this.isTrySpin = isTrySpin;
    this.placeBet(undefined);
    this.startPlay();
  }

  /**
   * Makes BET API call
   * @param isFreeSpin - Changes payload for free spin BET API Call
   */
  placeBet(isFreeSpin?: boolean) {
    let payload: any = {
      game: this.lootboxId,
      isDemo: this.isTrySpin || !!this.gameAPIService.getIsDemo,
    };
    if (this.gameSession) {
      payload = {
        ...payload,
        platform: PLATFORM_TYPES.WEBSITE,
        currency: this.isUSDDefault ? CURRENCY.USD : CURRENCY.EURO,
        preceedingBetBalance: this.userBalance,
        isFreeSpin: !!(this.sessionBalance[this.lootboxId]?.currentSessionFreeSpinBalance) || !!this.marketingFreeSpinBalance,
        updatedAt: this.lootboxUpdatedAt
      }
      // Deducts spin fee only when flow is not a free spin nor a try spin
      if (!this.sessionBalance[this.lootboxId]?.currentSessionFreeSpinBalance && !this.marketingFreeSpinBalance && !this.isTrySpin) {
        this.userBalance -= this.spinFee;
      } else if (this.sessionBalance[this.lootboxId]?.currentSessionFreeSpinBalance && !this.isTrySpin) {
        this.sessionBalance[this.lootboxId].currentSessionFreeSpinBalance--;
      } else if (this.marketingFreeSpinBalance && !this.isTrySpin) {
        this.marketingFreeSpinBalance--;
      }
    }
    this.subscriptions.push(
      this.apiService
        .post(
          API_Const.lootboxes.bet,
          payload,
          true
        )
        .subscribe({
          next: (res) => {
            const {
              result: { id = undefined },
            } = res;
            // INCASE BET API DOES NOT GIVE REWARD
            if (!id) {
              this.spinHasError = true;
              this.prizeCardIndex = this.weightedRandom(this.weights);
              this.checkUserBalance();
              return;
            }
            this.prizeCardIndex = +id;
            this.prizeWon = this.cards.filter(
              (prize) => prize.prizeId === this.prizeCardIndex
            )[0];

            // PRELOADS IMAGES FOR SPIN WIN UI
            if (this.spinWinBg !== this.prizeWon?.prizeWinImage) {
              this.spinWinBg = this.prizeWon?.prizeWinImage ?? '';
            }
            if (this.prizeBg !== (this.prizeWon?.imageUrl || this.prizeWon?.nft?.img)) {
              this.prizeBg = this.prizeWon?.imageUrl || this.prizeWon?.nft?.img || '';
            }
          },
          error: (err: HttpErrorResponse) => {
            this.spinHasError = true;
            this.prizeCardIndex = this.weightedRandom(this.weights);
            // Return when status is 0, interceptor handles this error
            if (!err.status) {
              return;
            }
            if (err?.status === 409) {
              this.lootboxUpdated = true;
              this.popupService.messagePopup('warning', MESSAGES.PRIZE_UPDATED, 'Ok', undefined, undefined, undefined, false).then((result) => { location.reload() });
              return;
            }
            if (err?.status === STATUS_CODES.NOT_FOUND) {
              this.sound.volume = 0;
              this.popupService.messsageAlert("error", MESSAGES.GAME_INACTIVE);
              this.router.navigate([this.lang, "lootboxes"], {
                queryParams: {
                  token: localStorage.getItem(STORAGE_KEYS.SESSION),
                  is_demo: localStorage.getItem(STORAGE_KEYS.IS_DEMO),
                  currency: localStorage.getItem(STORAGE_KEYS.CURRENCY),
                  platform: localStorage.getItem(STORAGE_KEYS.PLATFORM)
                }
              });
              return;
            }
            if (!this.isTrySpin) {
              this.checkUserBalance();
              this.popupService.messsageAlert("error", err?.error?.message ?? 'Something went wrong!');
            }
          },
        })
    );
  }

  /**
   * Starts the spin
   * @returns void
   */
  startPlay() {
    this.stopSpinning = false;
    if (this.running) return;
    this.prizeCardIndex = -1;
    this.running = true;
    this.listenEvents();
    if (!this.isFastSpin) {
      this.handleNormalSpeed();
      return;
    }

    this.handleFastSpeed();
  }

  /**
   * Adds a callback to the pixi app and listens to events
   */
  listenEvents() {
    this.pixi.ticker.add(this.animationCallBack);
  }

  /**
   * Handles the time specific speed incase of normal spin
   */
  handleNormalSpeed() {
    this.controlSpeed(3500, 150, 10);
  }

  /**
   * Handles the time specific speed incase of fast spin
   */
  handleFastSpeed() {
    this.controlSpeed(1000, 100, 10);
  }

  /**
   * 
   * @param totalDuration 
   * @param maxSpeed 
   * @param decreaseDuration 
   * @param finalSpeed 
   */
  controlSpeed(totalDuration: number, maxSpeed: number, finalSpeed: number) {
    this.speed = maxSpeed;
    const decreaseStep = (maxSpeed - finalSpeed) / (totalDuration / 50);
    let currentSpeed = maxSpeed;
    let elapsedTime = 0;

    this.subscriptions.push(interval(50).pipe(
      takeWhile(() => elapsedTime < totalDuration)
    ).subscribe(() => {
      if (elapsedTime < totalDuration) {
        currentSpeed = Math.max(finalSpeed, currentSpeed - decreaseStep);
      } else {
        currentSpeed = finalSpeed;
      }

      this.speed = currentSpeed;
      elapsedTime += 50;

      if (elapsedTime >= totalDuration) {
        this.finalizeSpeedControl(finalSpeed, totalDuration + 1500);
      }
    }));
  }


  /**
   * Reduces the speed after fast speed is executed
   */
  finalizeSpeedControl(currentSpeed: number, totalTime: number) {
    if (!this.prizeCardIndex) {
      this.prizeCardIndex = this.weightedRandom(this.weights);
    } else {
      this.stopSpinning = true;
    }
    let prizeIndex: number[] = [];
    this.reelContainer.children.forEach((child: ContainerChild, index) => {
      if (+child.label === this.prizeCardIndex) {
        prizeIndex.push(index);
      }
    });
    let cardsToSkip = this.reelContainer.children.length - this.previousHighlightedIndex + prizeIndex[0];
    const timeInterval = +(totalTime / cardsToSkip).toFixed(1);
    const speedInterval = +(((2 * currentSpeed) / (3 * cardsToSkip))).toFixed(1);

    this.subscriptions.push(interval(timeInterval).pipe(
      takeWhile(() => cardsToSkip > 0 && this.speed > speedInterval)
    ).subscribe(() => {
      this.speed -= speedInterval;
      this.speed = +this.speed.toFixed(1);
      cardsToSkip--;
    }));
  }

  /**
   * Processes each card position and updates it
   * 
   */
  animationCallBack = () => {
    this.reelContainer.children.forEach((sprite: Container, index: number) => {
      sprite.x -= this.speed; // You can adjust the velocity here
      if (sprite.x <= -90) {
        let newIndex = index !== 0 ? index - 1 : this.reelContainer.children.length - 1;
        sprite.x = this.reelContainer.children[newIndex].x + 210;
        if (index) {
          sprite.x -= this.speed / this.speed;
        } else {
          sprite.x -= this.speed;
        }
      }
      this.highlightCenterCard(sprite, index);
    });
  };

  /**
   * Highlights the center card with border
   * @param sprite - Sprite instance
   * @param index - The index of sprite in the queue
   */
  highlightCenterCard(sprite: Container, index: number) {
    const leftEdge = sprite.x + (this.getXOffset);
    let cardIsCentered = (this.arrowPosition) - (leftEdge) >= 0 &&
      (this.arrowPosition) - (leftEdge) <= 200;
    if (this.isMobile) {
      const arrowCenter = this.arrowPosition + 24;
      cardIsCentered = sprite.x > 0 &&
        sprite.x < this.spinnerContainer.offsetWidth &&
        arrowCenter - sprite.x < 90 &&
        sprite.x - arrowCenter < 90;
    }
    if (cardIsCentered) {

      if (this.previousHighlightedIndex !== index) {
        this.previousHighlightedIndex = index;
        if (!this.tickerSoundPlayed) {
          this.sound.play();
          this.tickerSoundPlayed = true; // Mark sound as played for current highlight
        }
        const border = new Graphics()
          .roundRect(0, 0, this.cardWidth, this.cardHeight, 14)
          .stroke({
            width: 2,
            color: "#F8AC2F",
          });
        this.reelContainer.children[index].addChild(border);

        // REMOVES BORDER FROM PREVIOUS CARDS IF PRESENT
        if (index) {
          const previousChild = this.reelContainer.children[index - 1];
          this.removeBorder(previousChild, index - 1);
        }
        if (this.stopSpinning && this.prizeCardIndex === +this.reelContainer.children[index].label) {
          this.handlePrizeWin();
        }
      }
    } else {
      this.removeBorder(sprite, index)
    }
  }

  removeBorder(sprite: Container, index: number) {
    const borderIndex = sprite.children.findIndex(
      (child) => child instanceof Graphics
    );

    if (borderIndex !== -1) {
      sprite.removeChildAt(borderIndex);
    }
    // Reset tickerSoundPlayed flag when the card is not centered
    if (this.previousHighlightedIndex === index) {
      this.tickerSoundPlayed = false;
    }
  }

  /**
   * Handles Flow when the prize won by the user comes under the center arrow
   */
  handlePrizeWin() {
    this.subscriptions.push(
      rxSetTimeout(200).pipe(
        tap(() => {
          this.speed = 0;
          this.pixi.ticker.remove(this.animationCallBack);
        }),
        // Adding another delay of 400ms before checking the running state and calling showPrizeWon
        tap(() => rxSetTimeout(200).subscribe(() => {
          if (!this.spinHasError) {
            if (this.running && !this.isTrySpin) {
              this.showPrizeWon();
            }
          } else {
            this.speed = 0;
            if (!this.isTrySpin && !this.lootboxUpdated) {
              this.popupService.messsageAlert("error", "Something went wrong!");
              this.spinHasError = false;
              this.checkUserBalance();
            }
          }
          this.running = false;
        }))
      ).subscribe()
    )
  }

  /**
   * Generates Card like UI for NFT Card
   * @param cardContainer - CUrrent card container instance
   * @param name - Name of NFT
   * @param price - Price of NFT
   */
  generateNFTCard(cardContainer: Container, name: string, id: string, price: number) {
    const title = new Text({
      text: "NFT",
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "700",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      x: this.cardWidth / 2 - 12,
      y: 12,
      roundPixels: true
    });
    cardContainer.addChild(title);

    const collectionIdContainer = new Container();
    const nftId = new Text({
      text: id.length > 16 ? id?.substring(0, 16) + '...' : id,
      resolution: 2,
      style: {
        fontSize: 12,
        fontWeight: "500",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      roundPixels: true,
      y: -10
    });

    collectionIdContainer.x = (this.cardWidth - nftId.width) / 2;
    collectionIdContainer.y = this.cardHeight - 56;
    collectionIdContainer.addChild(nftId);

    const collectionNameContainer = new Container();
    const nftName = new Text({
      text: name.length > 16 ? name?.substring(0, 16) + '...' : name,
      resolution: 2,
      style: {
        fontSize: 12,
        fontWeight: "500",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      roundPixels: true,
      y: 6
    });
    collectionNameContainer.x = (this.cardWidth - nftName.width) / 2;
    collectionNameContainer.y = this.cardHeight - 56;
    collectionNameContainer.addChild(nftName);
    cardContainer.addChild(collectionIdContainer);
    cardContainer.addChild(collectionNameContainer);

    const footerContainer = new Container();

    const img = new Sprite({
      texture: Texture.from(`assets/images/svg-icons/${this.isUSDDefault ? 'usd-coin' : 'euro-coin'}.svg`),
      height: 28,
      width: 28,
      y: -2,
      roundPixels: true,
    });
    // Adding img to footer container
    footerContainer.addChild(img);

    const footerTwo = new Text({
      text: `${this.isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}${convertNumToCurr(price)}`,
      resolution: 2,
      style: {
        fontSize: 16,
        fontWeight: "800",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      roundPixels: true,
      x: 28,
      y: 2
    });

    // Adding text to footer container
    footerContainer.addChild(footerTwo);

    // Centering the footer container and adding to card
    footerContainer.y = this.cardHeight - 32;
    footerContainer.x = (this.cardWidth - (footerTwo.width + 28)) / 2;
    cardContainer.addChild(footerContainer);
  }

  /**
 * Generates Card like UI for NFT Card
 * @param cardContainer - CUrrent card container instance
 * @param name - Name of NFT
 * @param price - Price of NFT
 */
  generateCustomPrizeCard(cardContainer: Container, prize: ILootboxCard) {
    const customTitleContainer = new Container();
    const customPrizeLabel = prize?.customPrize?.customPrizeLabel as string;
    const title = new Text({
      text: (customPrizeLabel).length > 16 ? customPrizeLabel?.substring(0, 16) + '...' : customPrizeLabel,
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "700",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      roundPixels: true,
    });
    customTitleContainer.x = (this.cardWidth - title.width) / 2;
    customTitleContainer.y = 12;
    customTitleContainer.addChild(title);
    cardContainer.addChild(customTitleContainer);

    const customDescContainer = new Container();
    const customDescription = new Text({
      text: (prize?.customPrize?.customPrizeDesc as string).length > 16 ? prize?.customPrize?.customPrizeDesc?.substring(0, 16) + '...' : prize?.customPrize?.customPrizeDesc,
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "500",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      roundPixels: true,
      y: prize.tokenQuantity ? 6 : 16
    });

    customDescContainer.x = (this.cardWidth - customDescription.width) / 2;
    customDescContainer.y = this.cardHeight - 48;
    customDescContainer.addChild(customDescription);

    cardContainer.addChild(customDescContainer);

    if (prize.tokenQuantity) {
      const footerContainer = new Container();

      const img = new Sprite({
        texture: Texture.from(`assets/images/svg-icons/${this.isUSDDefault ? 'usd-coin' : 'euro-coin'}.svg`),
        height: this.isUSDDefault ? 28 : 22,
        width: this.isUSDDefault ? 28 : 22,
        y: this.isUSDDefault ? -2 : 0,
        roundPixels: true
      });
      if (!this.isUSDDefault) {
        img.x = 2;
      }
      // Adding img to footer container
      footerContainer.addChild(img);

      const footerTwo = new Text({
        text: `${this.isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}${convertNumToCurr(prize.tokenQuantity ?? 0)}`,
        resolution: 2,
        style: {
          fontSize: 16,
          fontWeight: "800",
          fontFamily: "Poppins",
          fill: this.eventService.getCssVariableValue('--titleColor'),
        },
        roundPixels: true,
        x: 28,
        y: 2
      });

      // Adding text to footer container
      footerContainer.addChild(footerTwo);

      // Centering the footer container and adding to card
      footerContainer.y = this.cardHeight - 26;
      footerContainer.x = (this.cardWidth - (footerTwo.width + 28)) / 2;
      cardContainer.addChild(footerContainer);
    }
  }

  /**
   * Generates Card like UI for free spin Card
   * @param cardContainer - Current instance of card container
   */
  generateFreeSpinCard(cardContainer: Container, freeSpin: number, wantBg?: boolean) {
    const bg = new Sprite({
      texture: Texture.from("assets/images/prize-spinner/free-spin-bg.png"),
      width: this.cardWidth - 32,
      height: 230,
      x: 16,
      y: 36,
      scale: 1,
      roundPixels: true
    });
    const title = new Text({
      text: "Free Spin",
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "700",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      x: this.cardWidth / 2 - 32,
      y: 12,
      roundPixels: true,
    });
    cardContainer.addChild(title);
    if (wantBg) {
      cardContainer.addChild(bg);
    }

    const footer = new Text({
      text: `${freeSpin} Spin`,
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "600",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      x: this.cardWidth / 2 - 24,
      y: this.cardHeight - 40,
      roundPixels: true,
    });

    cardContainer.addChild(footer);
    const footerTwoContainer = new Container();
    const footerTwo = new Text({
      text: "Lootboxes",
      resolution: 2,
      style: {
        fontSize: 16,
        fontWeight: "800",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      y: this.cardHeight - 24,
      roundPixels: true,
    });
    footerTwoContainer.addChild(footerTwo);
    footerTwoContainer.x = (this.cardWidth - footerTwo.width) / 2;
    cardContainer.addChild(footerTwoContainer);
  }

  /**
   * Generates Card like UI for bonus Card
   * @param cardContainer - Current instance of card container
   * @param amount - Amount of bonus
   */
  async generateCryptoCard(cardContainer: Container, prize: ILootboxCard, wantBg?: boolean) {
    const bg = new Sprite({
      texture: Texture.from("assets/images/prize-spinner/token-card.png"),
      width: this.cardWidth - 32,
      height: 230,
      x: 16,
      y: 36,
      scale: 1,
      roundPixels: true
    });
    const title = new Text({
      text: `${prize.currency?.currencyName.toUpperCase()}`,
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "700",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      y: 12,
      roundPixels: true,
    });

    title.x = (this.cardWidth - title.width) / 2
    if (wantBg) {
      cardContainer.addChild(bg);
    }
    cardContainer.addChild(title);

    const footerContainer = new Container();
    const wsmLogo = new Sprite({
      texture: prize.currency?.currencyName ? Texture.from(`assets/images/currency/${prize.currency?.currencyName}-logo.webp`) : Texture.from("assets/images/svg-icons/wall-token.svg"),
      height: 20,
      width: 20,
      y: 2,
      roundPixels: true,
    });
    footerContainer.addChild(wsmLogo);
    const footer = new Text({
      text: `${convertNumToCurr(prize.tokenQuantity ?? 0)} ${prize.currency?.currencyName.toUpperCase()}`,
      resolution: 2,
      style: {
        fontSize: 16,
        fontWeight: "800",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      x: 24,
      y: 2,
      roundPixels: true,
    });
    footerContainer.addChild(footer);
    footerContainer.y = this.cardHeight - 32;
    footerContainer.x = (this.cardWidth - footerContainer.width) / 2;

    cardContainer.addChild(footerContainer);
  }

  /**
   * Generates a pixijs card for Cash reward
   * @param cardContainer - Container instance of Reward card
   * @param amount - Cash Reward Amount
   * @param currencySymbol - Image of currency
   */
  generateCashCard(cardContainer: Container, amount: number, currencySymbol: string, wantBg?: boolean) {
    const bg = new Sprite({
      texture: Texture.from("assets/images/prize-spinner/cash-reward-bg.png"),
      width: this.cardWidth - 32,
      height: 230,
      x: 16,
      y: 36,
      scale: 1,
      roundPixels: true
    });
    const title = new Text({
      text: `${this.isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}CASH`,
      resolution: 2,
      style: {
        fontSize: 14,
        fontWeight: "700",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      x: this.cardWidth / 2 - 24,
      roundPixels: true,
      y: 12,
    });
    if (wantBg) {
      cardContainer.addChild(bg);
    }
    cardContainer.addChild(title);

    const footerContainer = new Container();

    const wsmLogo = new Sprite({
      texture: Texture.from(currencySymbol),
      height: this.isUSDDefault ? 28 : 22,
      width: this.isUSDDefault ? 28 : 22,
      roundPixels: true,
      y: this.isUSDDefault ? -2 : 0,
    });
    if (!this.isUSDDefault) {
      wsmLogo.x = 2;
    }
    footerContainer.addChild(wsmLogo);
    const footer = new Text({
      text: `${this.isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}${convertNumToCurr(amount)}`,
      resolution: 2,
      style: {
        fontSize: 16,
        fontWeight: "800",
        fontFamily: "Poppins",
        fill: this.eventService.getCssVariableValue('--titleColor'),
      },
      x: 28,
      roundPixels: true,
      y: 2
    });
    footerContainer.addChild(footer);
    footerContainer.y = this.cardHeight - 32;
    footerContainer.x = (this.cardWidth - footerContainer.width) / 2;

    cardContainer.addChild(footerContainer);
  }

  /**
   * Get screen specific x position such that card remains at center
   * @returns
   */
  get getXOffset(): number {
    const cardWithGap = this.cardWidth + 6;
    const leftSide = this.spinnerContainer.offsetWidth / 2 - cardWithGap / 2;
    const completeCards = Math.floor(leftSide / cardWithGap);
    const trimmedCard = leftSide - completeCards * cardWithGap;
    return (cardWithGap - trimmedCard + 3) * -1;
  }

  showPrizeWon() {
    if (this.gameAPIService.getIsDemo) {
      window.open(BH_LOGIN_URL, "_parent");
      return;
    }
    const spinWinSound = this.getSpinWinSound(this.prizeWon.type);
    spinWinSound.play();
    this.checkUserBalance();
    let value = this.prizeWon.tokenQuantity;
    if (this.prizeWon.type === SPIN_WIN_PRIZES.NFT) {
      value = this.prizeWon.nft?.resellValue;
    } else if (this.prizeWon.type === SPIN_WIN_PRIZES.CUSTOM) {
      value = this.isUSDDefault ? this.prizeWon.customPrize?.customPrizeRevalueUsd
        : this.prizeWon.customPrize?.customPrizeRevalueEuro
    }
    this.spinWinModalRef = this.modalService.show(SpinWinComponent, {
      id: "SPIN_WIN_MODAL",
      class: "modal-dialog-centered spin-win-dialog",
      backdrop: "static",
      animated: false,
      ignoreBackdropClick: false,

      initialState: {
        type: this.prizeWon.type,
        value,
        unit: this.isUSDDefault ? CURRENCY.USD : CURRENCY.EURO,
        prize: this.prizeWon
      },
    });

    if (this.prizeWon.type === SPIN_WIN_PRIZES.FREE_SPIN) {
        this.sessionBalance[this.lootboxId].currentSessionFreeSpinBalance += this.prizeWon.numberOfFreeSpin as number;
      
    }

    if (this.prizeWon.type !== SPIN_WIN_PRIZES.NFT && this.prizeWon.type !== SPIN_WIN_PRIZES.CUSTOM) {
      setTimeout(() => {
        this.spinWinModalRef.hide();
        spinWinSound.stop();
        if (this.sessionBalance[this.lootboxId]?.currentSessionFreeSpinBalance) {
          this.placeBet(true);
          this.startPlay();
        } else {
          this.checkFreeSpinBalance();
        }
      }, 4000);
    }

    this.spinWinModalRef.onHidden?.subscribe(() => {
      spinWinSound.stop();
      // User has sold the NFT/CUSTOM Prize
      if (this.spinWinModalRef.content.showSellPrize) {
        this.showCoinTransfer = true;
        this.checkUserBalance();
        setTimeout(() => {
          // Sending refresh as true because prizes are same, need to fetch latest updatedAt for the lootbox
          this.getLootboxDetails(true);
          this.showCoinTransfer = false;
          if (this.sessionBalance[this.lootboxId]?.currentSessionFreeSpinBalance) {
            this.placeBet(true);
            this.startPlay();
          } else {
            if (this.isTrySpin) {
              this.isTrySpin = false;
            }
            this.checkFreeSpinBalance();
          }
        }, 2500);
      } else if (this.prizeWon.type === SPIN_WIN_PRIZES.NFT || this.prizeWon.type === SPIN_WIN_PRIZES.CUSTOM) {
        // Player decides to keep the NFT/Custom Prize
        if (this.sessionBalance[this.lootboxId]?.currentSessionFreeSpinBalance) {
          this.placeBet(true);
          this.startPlay();
        } else {
          if (this.isTrySpin) {
            this.isTrySpin = false;
          } else {
            if (this.prizeWon.type === SPIN_WIN_PRIZES.NFT || (this.prizeWon.type === SPIN_WIN_PRIZES.CUSTOM && this.prizeWon.customPrize?.customPrizeType === CUSTOM_PRIZE_TYPE.REPLACEMENT)) {
              location.reload();
              return;
            }
            this.checkFreeSpinBalance();
          }
        }
      }
    });
  }

  /**
   * Returns sound according to the prize won
   * @param type - Type of reward won by the user
   * @returns Sound according to the prize won
   */
  getSpinWinSound(type: SPIN_WIN_PRIZES): Sound {
    let spinWinSound = Sound.from('/assets/sounds/small-win.wav');
    spinWinSound.volume = (0.1);
    switch (type) {
      case SPIN_WIN_PRIZES.NFT:
        spinWinSound = Sound.from('/assets/sounds/NFT_WIN.mp3');
        spinWinSound.volume = (0.03);
        return spinWinSound;
      case SPIN_WIN_PRIZES.FREE_SPIN:
        spinWinSound = Sound.from('/assets/sounds/free-spin-win.wav');
        spinWinSound.volume = (0.05);
        return spinWinSound;
      default:
        return spinWinSound;
    }
  }

  onAction(card: ILootboxCard) {
    if (card.type === SPIN_WIN_PRIZES.NFT) {
      this.router.navigate([this.lang, "nft", `${card.nft?.slug}`, card.nft?.id ?? `1241`], {
        queryParams: {
          prizeId: card.prizeId
        }
      });
    }
  }

  convertNumToCurr(num: number) {
    return convertNumToCurr(num);
  }


  back() {
    this.location.back();
  }

  get getSpinBtnAlignment(): string {
    return `calc(50% - ${!this.isProd ? '148' : '93'}px)`;
  }

  ngOnDestroy(): void {
    this.sound.volume = 0;
    this.speed = 0;
    this.pixi?.ticker?.remove(this.animationCallBack);
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}
